import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <>
        <footer className='main-footer'>
          <div className='pull-right hidden-xs'></div>
          <strong>
            © {new Date().getFullYear()}{' '}
            <a href='https://www.decathlon.in/' style={{ color: '#000' }}>
              Decathlon
            </a>{' '}
            Sports India Pvt Ltd. All rights reserved. .
          </strong>
        </footer>
      </>
    );
  }
}

export default Footer;
